import { render, staticRenderFns } from "./PersonInChargeManmonth.vue?vue&type=template&id=24804ede&scoped=true&"
import script from "./PersonInChargeManmonth.vue?vue&type=script&lang=js&"
export * from "./PersonInChargeManmonth.vue?vue&type=script&lang=js&"
import style0 from "./PersonInChargeManmonth.vue?vue&type=style&index=0&id=24804ede&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24804ede",
  null
  
)

export default component.exports